<template>
    <div id="AutomationTitle">
        <div class="block-title-container d-flex flex-row justify-content-center align-items-center">
            <IconButton :on-click="goBack">
                <span class="material-icons cb-back-button"> chevron_left </span>
            </IconButton>
            <input
                ref="editStoryName"
                :placeholder="$t('chatbotv2.typeAutomationTitle')"
                :value="name"
                @input="name = $event.target.value"
                @blur="updateName()"
            />
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import IconButton from "../../../../Settings/components/IconButton.vue";

export default {
    name: "AutomationTitle",
    components: { IconButton },
    props: [],
    data() {
        return {
            name: "",
        };
    },
    computed: {
        ...mapState({
            automation: (state) => state.automation.current,
        }),
    },
    created() {
        this.name = this.automation.name;
    },
    methods: {
        ...mapActions({
            changeAutomationName: "automation/changeAutomationName",
        }),
        goBack() {
            if (window.sessionStorage.getItem("automation-selected-module") === "calendar") {
                console.log("goBack to calendar /calendar/automations");
                this.$router.push("/reservation/automations");
                window.sessionStorage.removeItem("automation-selected-module");
            } else if (window.sessionStorage.getItem("automation-selected-module") === "ticket") {
                console.log("goBack to ticket /ticket?tab=ticket-automations");
                this.$router.push("/ticket?tab=ticket-automations");
                window.sessionStorage.removeItem("automation-selected-module");
            } else if (window.sessionStorage.getItem("automation-selected-module") === "task") {
                console.log("goBack to tasks /tasks?type=automation");
                this.$router.push("/tasks?type=automation");
                window.sessionStorage.removeItem("automation-selected-module");
            }
            else if (window.sessionStorage.getItem("automation-selected-module") === "chat") {
                console.log("goBack to chat /chat?tabIndex=13");
                this.$router.push("/chat?tabIndex=13");
                window.sessionStorage.removeItem("automation-selected-module");
            } else {
                this.$router.push("/automations/all-automations");
            }
        },
        updateName() {
            this.changeAutomationName(this.name).then(() => {
                this.$message.success("Automation name updated");
            });
        },
    },
};
</script>

<style lang="scss">
#AutomationTitle {
    .cb-back-button {
        font-size: 40px !important;
    }

    .block-title-container {
        gap: 10px;

        input {
            background: none;
            border: 0;
            font-size: 22px;
            font-weight: 600;
            line-height: 28px;
            width: 100%;
            font-family: Source Sans Pro, sans-serif;
            cursor: context-menu;
        }
    }

    .representative-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;

        .representative-online {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #00ff00;
            margin-right: 10px;
        }
    }

    .representative-name {
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        display: -webkit-box;
    }

    .ant-btn:hover,
    .ant-btn:focus {
        color: #595959;
        background-color: #fff;
        border-color: #d9d9d9;
    }
}
</style>
